import { Routes } from '@angular/router';
import { Home } from './components/pages/home/home';

export const routes: Routes = [
  {
    path: '',
    component: Home,
    title: 'Psicóloga en Santander y online | Ana Pellón',
    data: {
      description:
        'Psicóloga sanitaria en Santander. Atención psicológica presencial y online para adultos, adolescentes e infancia.',
    },
  },
  {
    path: 'sobre-mi',
    loadComponent: () => import('./components/pages/about-me/about-me').then((m) => m.AboutMe),
    title: 'Psicóloga en Santander | Ana Pellón',
    data: {
      description:
        'Conoce a Ana Pellón, psicóloga sanitaria en Santander, su enfoque de trabajo y la forma en que acompaña procesos terapéuticos con cercanía y claridad.',
    },
  },
  {
    path: 'servicios',
    loadComponent: () => import('./components/pages/services/services').then((m) => m.Services),
    title: 'Servicios de psicología en Santander y online | Ana Pellón',
    data: {
      description:
        'Servicios de psicología para adultos, adolescentes e infancia. Atención presencial en Santander y online.',
    },
  },
  {
    path: 'servicios/terapia-infantil',
    loadComponent: () =>
      import('./components/pages/services/service-child/service-child').then((m) => m.ServiceChild),
    title: 'Psicóloga infantil en Santander | Ana Pellón',
    data: {
      description:
        'Atención psicológica infantil en Santander en un espacio seguro y adaptado a cada niño y su familia.',
    },
  },
  {
    path: 'servicios/terapia-adolescentes',
    loadComponent: () =>
      import('./components/pages/services/service-teen/service-teen').then((m) => m.ServiceTeen),
    title: 'Psicóloga para adolescentes en Santander y online | Ana Pellón',
    data: {
      description:
        'Atención psicológica para adolescentes en Santander y online, con acompañamiento en procesos de ansiedad, autoestima, identidad y malestar emocional.',
    },
  },
  {
    path: 'servicios/terapia-adultos',
    loadComponent: () =>
      import('./components/pages/services/service-adult/service-adult').then((m) => m.ServiceAdult),
    title: 'Terapia para adultos en Santander y online | Ana Pellón',
    data: {
      description:
        'Atención psicológica para adultos en Santander y online, con acompañamiento en procesos de ansiedad, autoestima y malestar emocional.',
    },
  },
  {
    path: 'servicios/preguntas-frecuentes',
    loadComponent: () => import('./components/pages/services/faqs/faqs').then((m) => m.Faqs),
    title: 'Preguntas frecuentes sobre terapia en Santander y online | Ana Pellón',
    data: {
      description:
        'Resuelve tus dudas sobre la terapia: primera sesión, duración, frecuencia, confidencialidad y atención a adultos, adolescentes e infancia.',
    },
  },
  {
    path: 'espacio-de-trabajo',
    loadComponent: () => import('./components/pages/workspace/workspace').then((m) => m.Workspace),
    title: 'Consulta de psicología en Santander | Ana Pellón',
    data: {
      description:
        'Conoce el espacio de consulta de Ana Pellón en Santander, un entorno sereno, cuidado y confidencial para el acompañamiento terapéutico.',
    },
  },
  {
    path: 'contacto',
    loadComponent: () => import('./components/pages/contact/contact').then((m) => m.Contact),
    title: 'Pedir cita con psicóloga en Santander y online | Ana Pellón',
    data: {
      description:
        'Contacta con Ana Pellón para pedir cita en su consulta de psicología en Santander o para recibir atención online.',
    },
  },
  {
    path: 'aviso-legal',
    loadComponent: () =>
      import('./components/pages/legal-advice/legal-advice').then((m) => m.LegalAdvice),
    title: 'Aviso Legal',
    data: { description: 'Aviso legal y condiciones de uso.', robots: 'noindex,follow' },
  },
  {
    path: 'politica-de-cookies',
    loadComponent: () =>
      import('./components/pages/cookies-policy/cookies-policy').then((m) => m.CookiesPolicy),
    title: 'Política de Cookies',
    data: { description: 'Información sobre el uso de cookies.', robots: 'noindex,follow' },
  },
  {
    path: 'politica-de-privacidad',
    loadComponent: () =>
      import('./components/pages/privacy-policy/privacy-policy').then((m) => m.PrivacyPolicy),
    title: 'Política de Privacidad',
    data: {
      description: 'Política de protección de datos y privacidad.',
      robots: 'noindex,follow',
    },
  },
  { path: '**', redirectTo: '' },
];
